import { render, staticRenderFns } from "./createRequestForm.vue?vue&type=template&id=00c4e667&scoped=true"
import script from "./createRequestForm.vue?vue&type=script&lang=js"
export * from "./createRequestForm.vue?vue&type=script&lang=js"
import style0 from "./createRequestForm.vue?vue&type=style&index=0&id=00c4e667&prod&lang=scss"
import style1 from "./createRequestForm.vue?vue&type=style&index=1&id=00c4e667&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c4e667",
  null
  
)

export default component.exports